import { tracked } from '@glimmer/tracking';

import FilterSortBoardAtSelectPopup from 'webapp/models-custom/filter-sort/board-at-select-popup';

export default class FilterSortBoardAtSelectPopupInGrid extends FilterSortBoardAtSelectPopup {
	@tracked override viewId = 'grid';
	override itemDomSelector = 'li.filter-sort-item';
}
